import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckSquare, faSquare } from '@fortawesome/free-regular-svg-icons';
export const VanillaReviewerCheckbox = (props)=>{
    const { value, className, onClick, onChange, ...rest } = props;
    const onIconClick = (e)=>{
        props.onClick && props.onClick(e);
        props.onChange(!props.value, e);
    };
    return /*#__PURE__*/ _jsx(FontAwesomeIcon, {
        icon: value ? faCheckSquare : faSquare,
        className: classnames('clickable reviewer-checkbox', className),
        onClick: onIconClick,
        ...rest
    });
};
